import React, { useContext } from "react";
import styled from "@emotion/styled";
import { sum } from "d3-array";

import Board from "~/components/Board";
import ElectionGrid from "~/components/Board/layers/ElectionGrid";
import DrawLayer from "~/components/Drawer/DrawLayer";

import { TranslationContext } from "~/kits/general/scripts/app.js";
import { is768Query } from "~/core/scripts/mediaquery-helper";
import { allPossibleDrawStates, isBidenWinner } from "./utils";

const TwoColumns = styled.div`
  display: flex;
  position: relative;
  ${({ theme }) => theme.snippets.paddingLikeText}

  max-width: 760px;
  margin: 48px auto;

  ${({ theme }) => theme.breakpoints.sm.down} {
    margin: 24px auto;
    flex-wrap: wrap;
  }
`;

const Column = styled.div`
  flex: 0 0 50%;
  pointer-events: all;
`;

const ColumnTitle = styled.h5`
  text-align: center;
  font-size: 18px;
  margin: 4px 0;
  ${({ theme }) => theme.breakpoints.sm.down} {
    font-size: 15px;
  }
`;

const SolutionBoard = styled.div`
  margin: 16px;
  pointer-events: none;
  ${({ theme }) => theme.breakpoints.sm.down} {
    margin: 16px 4px;
  }
`;

const Text = styled.p`
  font-family: ${(p) => p.theme.fonts.serif};
  font-size: 1.5rem;
  line-height: 1.7;
  flex: 0 0 60%;
  box-sizing: border-box;

  ${({ theme }) => theme.breakpoints.sm.up} {
    padding-left: 32px;
  }
  ${({ theme }) => theme.breakpoints.sm.down} {
    flex-basis: 100%;
    margin-top: 24px;
    margin-bottom: 24px;
  }

  @media screen and (min-width: 400px) {
    font-size: 1.6rem;
  }
  @media screen and (min-width: 640px) {
    font-size: 1.9rem;
  }
`;

const Solution = () => {
  const polyglot = useContext(TranslationContext);
  const isDesktop = is768Query();
  const drawStatesBidenWon = allPossibleDrawStates.filter(
    (state) => sum(state.map(isBidenWinner)) >= 2
  );
  const drawStatesTrumpWon = allPossibleDrawStates.filter(
    (state) => sum(state.map(isBidenWinner)) < 2
  );
  return (
    <>
      <TwoColumns>
        <Column>
          <ColumnTitle
            dangerouslySetInnerHTML={{
              __html: polyglot.t("candidateWinsX", {
                x: drawStatesBidenWon.length,
                candidate: `<span class="_democratic_">Biden</span>`,
              }),
            }}
          />
          {drawStatesBidenWon.map((resultState, i) => (
            <SolutionBoard key={`solution-biden-${i}`}>
              <Board>
                <ElectionGrid tiny={!isDesktop} small={isDesktop} />
                <DrawLayer small hideNumbers resultState={resultState} />
              </Board>
            </SolutionBoard>
          ))}
        </Column>
        <Column>
          <ColumnTitle
            dangerouslySetInnerHTML={{
              __html: polyglot.t("candidateWinsX", {
                x: drawStatesTrumpWon.length,
                candidate: `<span class="_republican_">Trump</span>`,
              }),
            }}
          />
          {drawStatesTrumpWon.map((resultState, i) => (
            <SolutionBoard key={`solution-trump-${i}`}>
              <Board>
                <ElectionGrid tiny={!isDesktop} small={isDesktop} />
                <DrawLayer small hideNumbers resultState={resultState} />
              </Board>
            </SolutionBoard>
          ))}
        </Column>
      </TwoColumns>
    </>
  );
};

export default Solution;
